import React, {  forwardRef, ReactNode } from "react";
import styles from "./CustomSearchField.module.scss";

interface CustomSearchFieldProps {
  icon?: ReactNode;
  label?: string;
  content: ReactNode;
  className?: string;
  name?: string;
  onClick?: (prev?:any) => void;
  currency?: boolean;
  error?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  disabled?: boolean;
  isDestination?: boolean
  isSearchForm?: boolean;
  isBannerBox?: boolean;
}

const CustomSearchField = forwardRef<HTMLDivElement, CustomSearchFieldProps>(
  (props, ref) => {
    const { label, onClick, currency, icon, className, content, error, disabled, isBannerBox, isSearchForm, isDestination } = props;

    return (
      <div
        className={`${styles.SearchField} ${className} ${error ? styles.error : ""} ${disabled ? styles.disabled : ""} ${isBannerBox ? "!min-h-10" : ""} min-h-[48px] min-w-[48px]`}
        data-testid="CustomSearchField"
        onClick={onClick}
        ref={ref}
        role="button"
        // tabIndex={0}
        aria-label={label}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onClick?.();
        }}

      >

        <div className={`flex justify-center  w-full flex-col ${isDestination ? "" : "gap-1"} `}>
          <label
            className={`${styles.label} ${currency && styles.currencyLabel} font-medium ${isSearchForm ? "md:ps-[32px] ps-7 " : ""} `}
          >
            {label}
          </label>
          <div className="flex items-center gap-2">

            {icon && <span className={styles.icon}>{icon}</span>}

            <span className="w-full">{content}</span>
          </div>
        </div>
      </div>
    );
  }
);

export default CustomSearchField;
